module.exports = __webpack_public_path__ + "img/about_logo_27.0b2961ba.png";